import {storyblokEditable, useStoryblokApi} from "@storyblok/react";
import Image from "next/image";
import Link from "next/link";
import classNames from "classnames";
import ButtonGroup from "../partials/ButtonGroup";
import {transformImage} from "../../utils/StoryblokService";
import LinePattern from "../partials/LinePattern";
import {StarIcon} from "@heroicons/react/20/solid";
import {richTextResolver} from "@storyblok/richtext";

export default function QuoteSection(props: { blok: any }) {
    const { render } = richTextResolver()
    const blok = props.blok;

    let quoteAuthorImage = blok.quote_image?.filename ? transformImage(blok.quote_image.filename, blok.quote_imagesize || 'fit-in/250x250/filters:fill(transparent):format(png)') : '/images/ceo_inset.webp';


    return (
        <div
            className={classNames("overflow-hidden", blok.class, blok.container_padding || "py-16 sm:py-16 lg:py-24")} {...storyblokEditable(blok)}>
            <div className="mx-auto max-w-7xl space-y-8 px-4 sm:px-6 lg:px-8">
                <div className="w-4/5 mx-auto">
                    <div
                        data-aos={'fade-in'}
                        className="relative mx-auto mt-12 max-w-prose text-base lg:mt-0 lg:max-w-none self-center">

                        <LinePattern
                            class={'absolute w-[60%] opacity-20 top-0 right-0 -mt-10 -mr-10 lg:top-auto lg:right-auto lg:bottom-1/2 lg:left-1/2 lg:mt-0 lg:mr-0 xl:top-0 xl:right-0 xl:-mt-20 xl:-mr-20'}/>

                        <blockquote
                            className="relative rounded-lg bg-white shadow-lg hover:shadow-2xl transition-all duration-500">
                            <div className="rounded-t-lg px-6 py-8 sm:px-10 sm:pt-10 sm:pb-8">
                                {blok.show_logo &&
                                    <div className={'relative aspect-[1/.17] max-w-xs'}><Image
                                        className="block h-12 w-auto"
                                        fill={true}
                                        src={'/images/SVG/logo_v3.svg'}
                                        alt="Pacific Codeline LLC Logo"
                                    /></div>}
                                <div className="relative mt-8 text-lg font-medium text-gray-700">
                                    <svg
                                        className="absolute top-0 left-0 h-8 w-8 -translate-x-3 -translate-y-2 transform text-gray-200 opacity-25"
                                        fill="currentColor"
                                        viewBox="0 0 32 32"
                                        aria-hidden="true"
                                    >
                                        <path
                                            d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"/>
                                    </svg>

                                    {blok.show_stars &&
                                        <div className={'text-yellow-400 absolute right-0 -top-10'}>
                                            <StarIcon className={'inline-block h-5 w-5'}/>
                                            <StarIcon className={'inline-block h-5 w-5'}/>
                                            <StarIcon className={'inline-block h-5 w-5'}/>
                                            <StarIcon className={'inline-block h-5 w-5'}/>
                                            <StarIcon className={'inline-block h-5 w-5'}/>
                                        </div>}

                                    <div className={'md:grid grid-cols-3 items-center gap-4'}>
                                        <div className={classNames({
                                            'relative': true,
                                            'col-span-2': blok.image.id,
                                            'col-span-3': !blok.image.id
                                        })}>
                                            <div dangerouslySetInnerHTML={{
                                                __html: render(blok.quote) as string
                                            }}/>
                                        </div>
                                        {blok.image.id && blok.image.filename &&
                                            <div className={'relative aspect-video pl-4 mr-auto w-32 md:w-64 md:ml-auto'}>
                                            <Image
                                                src={transformImage(blok.image.filename, blok.imagesize)}
                                                className={"shrink-0 object-contain"}
                                                alt={blok.image.alt}
                                                fill={true}
                                            /></div>}
                                    </div>
                                </div>
                            </div>

                            <cite
                                className="relative flex gap-x-4 items-center rounded-b-lg bg-primary py-5 px-6 not-italic sm:mt-10 sm:items-start sm:py-5 sm:pl-12 sm:pr-10">


                                            <span
                                                className="relative shrink-0 rounded-full border-2 border-white sm:absolute sm:top-0 sm:-translate-y-1/2 sm:transform">
                  <Image
                      className="h-12 w-12 rounded-full bg-white sm:h-20 sm:w-20 object-contain"
                      src={quoteAuthorImage}
                      width={250}
                      height={250}
                      alt=""
                  />
                </span>
                                <span
                                    className={"relative font-semibold leading-6 text-secondary sm:pl-1 " + ((true) ? 'sm:ml-24' : '')}>

                  <span className="font-semibold text-white block sm:inline">
                      {blok.quote_person_name}
                  </span>{' '}
                                    <span className="sm:inline text-sm">
                                                {blok.quote_company}
                                            </span>
                </span>
                            </cite>
                        </blockquote>
                    </div>
                </div>
            </div>
        </div>
    )
}
